import { render } from "./NavbarComponent.vue?vue&type=template&id=10230e03"
import script from "./NavbarComponent.vue?vue&type=script&lang=ts"
export * from "./NavbarComponent.vue?vue&type=script&lang=ts"
script.render = render

export default script